import React,{useState,useEffect} from "react";
import { Link } from "react-router-dom";
import Sam from '../../assest/background/Sam.png';
import CurrencyInput from 'react-currency-input-field';

function InvestRealState6({onLoanInformationDataChange}) {

  document.title = "SimWealth";

  const [formData, setFormData] = useState({
    loanLTV: 80,
    loanInterestRate: 4.50,
    periodInYears: 30,
    loanType: "AMORTIZED",
  });

  const handleChange = (value, name) => {
    setFormData({
      ...formData,
      [name]: value,
    });

    onLoanInformationDataChange({ formData });
  };

  useEffect(() => {
    onLoanInformationDataChange({ formData });
  }, [onLoanInformationDataChange]);

  return (
    <>
      <div className="bg bg-InvestRealState1">
      <div data-aos="fade-left" className="container-fluid row  vh-100 w-100">
            <div className="col-sm-6  d-flex flex-column align-items-end justify-content-end my-auto  ">
                 <div className="bg-white rounded-border p-4 border border-4 text-center border-dark">
                  <p className="pb-3">Because Sam chose to obtain a mortgage to purchase his rental property, the loan information is shown below</p>
                  <div className="d-flex justify-content-end align-items-end my-3">
                    <label className="fs-18 me-4">Loan LTV</label>
                    <CurrencyInput
                      id="loanLTV"
                      name="loanLTV"
                      className="rounded"
                      placeholder="Loan LTV%"
                      suffix="%"
                      title="Valid range is 0% to 80%"
                      value={formData.loanLTV}
                      onValueChange={(value, name) => handleChange(value, name)}
                      disabled
                    />                    
                  </div>
                  <div className="d-flex my-3 justify-content-end align-items-end">
                    <label className="fs-18 me-4">Loan Interest Rate</label>
                    <CurrencyInput
                      id="loanInterestRate"
                      name="loanInterestRate"
                      className="rounded"
                      placeholder="Loan Interest Rate%"
                      suffix="%"
                      title="Valid range is 2% to 6%"
                      value={formData.loanInterestRate}
                      onValueChange={(value, name) => handleChange(value, name)}
                      disabled
                    />
                  </div>
                  <div className="d-flex my-3 justify-content-end align-items-end">
                    <label className="fs-18 me-4 text-nowrap">Period in Years</label>
                   <select className="form-select w-unset border-1 rounded border border-dark" 
                    value={formData.periodInYears}
                    onChange={(value, name) => handleChange(value, name)}
                    disabled
                   >
                          <option value={15}>15</option>
                          <option value={30}>30</option>
                      </select>
                  </div>
                  <div className="d-flex my-3 justify-content-end align-items-end">
                    <label className="fs-18 me-4 text-nowrap">Loan Type</label>
                    <select className=" form-select w-unset border-1 rounded border border-dark" 
                    value={formData.loanType}
                    onChange={(value, name) => handleChange(value, name)}
                    disabled
                    >
                          <option value={"AMORTIZED"}>AMORTIZED</option>
                          <option value={"INTEREST-ONLY"}>INTEREST-ONLY</option>
                      </select>
                  </div>
                  <Link to={'/investing-in-real-estate/seventh-step'} className=" threeDButton btn fw-bold  w-50  ">Continue</Link>
                </div> 

            </div>
            <div className="col-sm-6 d-flex  align-items-center justify-content-center position-relative">
            <Link to={'/choose-a-simulation'} className=" threeDButton btn fw-bold RightBtn ">MainMenu</Link>
            <img src={Sam} className="SamImage" alt="Sam" /></div>
        </div>
      </div>
    </>
  );
}

export default InvestRealState6;
